/**
 * Type guard to check if a value is either a number or a string that represents a number
 * @param value Value to check
 * @returns True if value is a number or numeric string, false otherwise
 */
export const isNumberString = (value: unknown): value is number | `${number}` => {
  if (typeof value === 'number') {
    return Number.isFinite(value)
  }

  if (typeof value !== 'string') {
    return false
  }

  // Check if string can be converted to a valid number
  const num = Number(value)
  return !Number.isNaN(num) && Number.isFinite(num)
}
